import React, { Component } from "react";
import { connect } from "react-redux";
import { pmaActions } from "_store/_actions";
import { GetOAuthToken, IsValidSessionSwitch } from "common/storage";
import { isUserAdmin } from "common/roles/role";
import QVThreeSecondLeftMarketIndicator from "./QVThreeSecondLeftMarketIndicator";
import SentenceTrends from "./SentenceTrends";
import SentenceTrendsOld from "./SentenceTrendsOld";
import YETwoYearInReview2024V4 from "./YETwoYearInReview2024/V4";
import SpeedometerPage from "./SpeedometerPage";
import PropAttributes from "./PropAttributes";
import FullSecondPageImage from "./FullSecondPageImage";
import HotBoxesAndTable from "./HotBoxesAndTable";
import "./styles.scss";
import "views/Pma/PmaEditor/CommonEditor/ivyprestoFonts.scss";

const DASHBOARD_MODULE_OPTIONS = [
  "SentenceTrends",
  "PropAttributes",
  "MarketIndicator",
  "YearInReview",
  "Speedometer",
  "HotBoxesAndTable",
  "FullSecondPageImage",
];

const normalizeDashboardModule = (moduleName) => {
  if (moduleName === "QVThreeSecondLeftMarketIndicator") {
    return "MarketIndicator";
  }
  if (moduleName === "SpeedometerPage") {
    return "Speedometer";
  }
  if (
    moduleName === "YETwoYearInReview2024" ||
    moduleName === "YearInReview2024"
  ) {
    return "YearInReview";
  }
  return moduleName;
};

const isAdminSessionAccess = () => {
  try {
    const token = GetOAuthToken();
    const oauthData = token ? JSON.parse(token) : null;
    return (
      (oauthData && isUserAdmin(oauthData.roleID)) || IsValidSessionSwitch()
    );
  } catch (err) {
    return IsValidSessionSwitch();
  }
};

class SecondPageComponents extends Component {
  state = {
    showModuleMenu: false,
    localDashboardPageModule: null,
  };

  toggleModuleMenu = () => {
    this.setState((prevState) => ({
      showModuleMenu: !prevState.showModuleMenu,
    }));
  };

  formatModuleName = (moduleName) => {
    if (moduleName === "SentenceTrends") return "3 Trends to Watch";
    if (moduleName === "PropAttributes") return "Property Attributes";
    if (moduleName === "MarketIndicator") return "Market Indicator";
    if (moduleName === "YearInReview") return "Year in Review";
    if (moduleName === "Speedometer") return "Speedometer";
    if (moduleName === "HotBoxesAndTable") return "Hot Boxes & Table";
    if (moduleName === "FullSecondPageImage") return "Full Page Image";
    return moduleName.replace(/([A-Z])/g, " $1").trim();
  };

  dashboardPageModuleSwitchButton = (dashboardPageModule) => {
    const { currentArea, agentData } = this.props;
    const { listgenUserID } = agentData;
    const { mlsAreaID } = currentArea;
    this.setState({
      localDashboardPageModule: dashboardPageModule,
      showModuleMenu: false,
    });
    this.props.setDashboardPageModule(
      listgenUserID,
      mlsAreaID,
      dashboardPageModule,
    );
  };

  render() {
    const {
      currentArea,
      hoData,
      agentData,
      printVersion,
      fromEditor,
      quarterlyAreaTable,
      quarterlyCityTable,
      hasFlippedTeam,
      aprilData,
      pmaQuarterlyCombinedCityDTO,
      MQCityDetails,
      dashboardValuation,
      tpTrends2WatchList,
      miniTableDetailsDTO,
      showAllEditButtons,
      keyMarketAvgsList,
      showMedian,
      priceRangeDashBoardDetailsDTOArea,
      priceRangeDashBoardDetailsDTOCity,
    } = this.props;

    const { mlsAreaID, dashboardPageModule: dashboardPageModuleRaw } =
      currentArea || {};
    const { listgenUserID } = agentData || {};
    const { showModuleMenu, localDashboardPageModule } = this.state;
    let useSingleFamilyHomes = false;
    let useCondosandTownhomes = false;
    if (mlsAreaID === "SMA-392") {
      useCondosandTownhomes = true;
    }
    if (
      mlsAreaID === "SMA-390" ||
      mlsAreaID === "SMA-398" ||
      mlsAreaID === "xSMA-392" ||
      listgenUserID === "109989"
    ) {
      useSingleFamilyHomes = true;
    }

    const dashboardPageModuleFromProps =
      typeof dashboardPageModuleRaw === "string" &&
      dashboardPageModuleRaw.trim() !== ""
        ? dashboardPageModuleRaw.trim()
        : null;

    const dashboardPageModuleMap = {
      SentenceTrends: () => (
        <SentenceTrends
          currentArea={currentArea}
          hoData={hoData}
          agentData={agentData}
          printVersion={printVersion}
          fromEditor={fromEditor}
          tpTrends2WatchList={tpTrends2WatchList}
          showAllEditButtons={showAllEditButtons}
        />
      ),
      SentenceTrendsOld: () => (
        <SentenceTrendsOld
          currentArea={currentArea}
          hoData={hoData}
          agentData={agentData}
          printVersion={printVersion}
          fromEditor={fromEditor}
        />
      ),
      MarketIndicator: () => (
        <QVThreeSecondLeftMarketIndicator
          currentArea={currentArea}
          hoData={hoData}
          agentData={agentData}
          aprilData={aprilData}
          printVersion={printVersion}
          hasFlippedTeam={hasFlippedTeam}
        />
      ),
      PropAttributes: () => (
        <PropAttributes
          agentData={agentData}
          MQCityDetails={MQCityDetails}
          printVersion={printVersion}
          fromEditor={fromEditor}
          showAllEditButtons={showAllEditButtons}
          currentArea={currentArea}
          hoData={hoData}
          quarterlyAreaTable={quarterlyAreaTable}
          quarterlyCityTable={quarterlyCityTable}
          dashboardValuation={dashboardValuation}
          priceRangeDashBoardDetailsDTOArea={priceRangeDashBoardDetailsDTOArea}
          priceRangeDashBoardDetailsDTOCity={priceRangeDashBoardDetailsDTOCity}
        />
      ),
      YearInReview: () => (
        <YETwoYearInReview2024V4
          currentArea={currentArea}
          hoData={hoData}
          aprilData={aprilData}
          pmaQuarterlyCombinedCityDTO={pmaQuarterlyCombinedCityDTO}
          agentData={agentData}
          printVersion={printVersion}
        />
      ),
      Speedometer: () => (
        <SpeedometerPage
          currentArea={currentArea}
          hoData={hoData}
          agentData={agentData}
          printVersion={printVersion}
          fromEditor={fromEditor}
          quarterlyAreaTable={quarterlyAreaTable}
          quarterlyCityTable={quarterlyCityTable}
          useSingleFamilyHomes={useSingleFamilyHomes}
          useCondosandTownhomes={useCondosandTownhomes}
          showMedian={showMedian}
        />
      ),
      FullSecondPageImage: () => (
        <FullSecondPageImage
          currentArea={currentArea}
          agentData={agentData}
          printVersion={printVersion}
          hoData={hoData}
        />
      ),
      HotBoxesAndTable: () => (
        <HotBoxesAndTable
          currentArea={currentArea}
          quarterlyAreaTable={quarterlyAreaTable}
          hoData={hoData}
          agentData={agentData}
          printVersion={printVersion}
          miniTableDetailsDTO={miniTableDetailsDTO}
          fromEditor={fromEditor}
          showAllEditButtons={showAllEditButtons}
          keyMarketAvgsList={keyMarketAvgsList}
        />
      ),
    };

    let fallbackDashboardPageModule = "PropAttributes";
    if (!dashboardPageModuleFromProps && !localDashboardPageModule) {
      if (listgenUserID === "101001") {
        fallbackDashboardPageModule = "FullSecondPageImage";
      } else if (mlsAreaID === "SFO-1AD") {
        fallbackDashboardPageModule = "PropAttributes";
      } else if (mlsAreaID === "SFO-4NA" || mlsAreaID === "SFO-8CA") {
        fallbackDashboardPageModule = "Speedometer";
      } else if (mlsAreaID === "SFO-2DC") {
        fallbackDashboardPageModule = "HotBoxesAndTable";
      } else if (mlsAreaID === "SFO-4RA" || listgenUserID === "100047") {
        fallbackDashboardPageModule = "SentenceTrends";
      }
    }

    const selectedDashboardPageModule = normalizeDashboardModule(
      localDashboardPageModule || dashboardPageModuleFromProps,
    );
    const activeDashboardPageModule = normalizeDashboardModule(
      selectedDashboardPageModule &&
        dashboardPageModuleMap[selectedDashboardPageModule]
        ? selectedDashboardPageModule
        : fallbackDashboardPageModule,
    );

    const renderDashboardPageModule =
      dashboardPageModuleMap[activeDashboardPageModule] ||
      dashboardPageModuleMap.PropAttributes;

    const showAdminSelector = fromEditor && isAdminSessionAccess();

    return (
      <div
        className={`second-page-dashboard-wrap${
          fromEditor ? " from-editor" : ""
        }`}
      >
        {showAdminSelector ? (
          <>
            <div
              className="dashboard-module-admin-btn"
              onClick={this.toggleModuleMenu}
              role="button"
              tabIndex={0}
            >
              <p>ADMIN:</p>
              <p>Select Dashboard</p>
            </div>
            {showModuleMenu ? (
              <div className="dashboard-module-menu">
                {DASHBOARD_MODULE_OPTIONS.map((module) => (
                  <div
                    key={module}
                    className={`dashboard-module-menu-item ${
                      activeDashboardPageModule === module ? "active" : ""
                    }`}
                    onClick={() => this.dashboardPageModuleSwitchButton(module)}
                  >
                    {this.formatModuleName(module)}
                  </div>
                ))}
              </div>
            ) : null}
          </>
        ) : null}
        {renderDashboardPageModule()}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setDashboardPageModule: (listgenUserID, mlsAreaID, dashboardPageModule) =>
    dispatch(
      pmaActions.setDashboardPageModule(
        listgenUserID,
        mlsAreaID,
        dashboardPageModule,
      ),
    ),
});

export default connect(null, mapDispatchToProps)(SecondPageComponents);
